import { render, staticRenderFns } from "./FinanceTabBalanceLedger.vue?vue&type=template&id=81cd6782&scoped=true"
import script from "./FinanceTabBalanceLedger.vue?vue&type=script&lang=js"
export * from "./FinanceTabBalanceLedger.vue?vue&type=script&lang=js"
import style0 from "./FinanceTabBalanceLedger.vue?vue&type=style&index=0&id=81cd6782&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81cd6782",
  null
  
)

export default component.exports